// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"3b7a7291","65":"3b7a7291","391":"3b7a7291","395":"3b7a7291","888":"82fd5f48","929":"b0848b26"}[chunkId] + ".chunk.css";
};